// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pesquisar_wrapper__1XOxK","input":"pesquisar_input__3XVZ6","label":"pesquisar_label__aEK69","error":"pesquisar_error__2i3eM"};